import request from '@/utils/request';
export const defaultProductData = {
  id: 0,
  enabled: true,
  schemesCategoryId: undefined,
  rangeId: undefined,
  name: null,
  label: null,
  productType: 'variable',
  priority: null,
  multiplier: 1,
  featured: false,
  isGiftItem: false,
  isNew: false,
  isMrpReduced: false,
  isMrpFurtherReduced: false,
  isIsi: false,
  isfreightAllowed: true,
  catalogueCode: undefined,
  boxesPerCarton: 0,
  piecesPerBox: 0,
  masterCarton: 0,
  suppliedBy: '',
  tags: null,
  shortDescription: null,
  description: null,
  isTaxable: true,
  taxId: null,
  hsnCode: null,
  videoUrl: null,
  manageStock: false,
  stockStatus: 'In Stock',
  tallyALias: null,
  tax: {
    id: undefined
  },
  schemesCategory: {
    id: undefined
  },
  range: {
    id: undefined
  },
  category: [],
  attribute: [],
  productsImage: [],
  productsVariation: []
};
export const getProducts = params => request({
  url: '/products',
  method: 'get',
  params
});
export const getProductById = (id, params = null) => request({
  url: `/products/${id}`,
  method: 'get',
  params
});
export const getProductVariationsById = (id, params = null) => request({
  url: `/products-variations/${id}`,
  method: 'get',
  params
});
export const updateProduct = (id, data) => request({
  url: `/products/${id}`,
  method: 'patch',
  data
});
export const downloadExcel = data => request({
  url: '/products/download-excel',
  method: 'post',
  data,
  responseType: 'blob'
});
export const deleteProduct = id => request({
  url: `/products/${id}`,
  method: 'delete'
});
export const createProduct = data => request({
  url: '/products/',
  method: 'post',
  data
});
export const productCount = params => request({
  url: '/products/count',
  method: 'get',
  params
});
export const updateProductCategories = (id, data) => request({
  url: `/products/categories/${id}`,
  method: 'patch',
  data
});
export const updateProductAttributes = (id, data) => request({
  url: `/products/attributes/${id}`,
  method: 'patch',
  data
});
export const searchProducts = params => request({
  url: '/products/search',
  method: 'get',
  params
});
export const searchDispatchedProducts = params => request({
  url: '/orders-dispatches/dispatched-products-list',
  method: 'get',
  params
});
export const getVariations = params => request({
  url: '/products-variations',
  method: 'get',
  params
});
export const getVariationById = id => request({
  url: `/products-variations/${id}`,
  method: 'get'
});
export const updateProductVariations = data => request({
  url: '/products-variations/manage',
  method: 'post',
  data
});
export const deleteProductVariation = id => request({
  url: `/products-variations/${id}`,
  method: 'delete'
});
export const updateProductImages = (id, data) => request({
  url: `/products/images/${id}`,
  method: 'patch',
  data
});
export const deleteProductImages = id => request({
  url: `/products-images/${id}`,
  method: 'delete'
});
export const updateProductInventories = (id, data) => request({
  url: `/products/inventories/${id}`,
  method: 'patch',
  data
});
export const uploadProductImages = data => request({
  url: '/products/images',
  method: 'post',
  data
});
export const uploadImages = data => request({
  url: '/products-images/upload',
  method: 'post',
  data
});
export const importProduct = data => request({
  url: '/products/file-import',
  method: 'post',
  data
});
export const setImageFromS3 = data => request({
  url: '/products-images/set-from-s3',
  method: 'post',
  data
});
export const getProductByFileName = params => request({
  // stub: expects server to implement a route that returns product by filename (catalogue code)
  url: '/products/by-filename',
  method: 'get',
  params
});
export const saveImage = data => request({
  url: '/products-images/save-image',
  method: 'post',
  data
});